export default __webpack_public_path__ + "static/media/user.78cdeea2.png";